import { render, staticRenderFns } from "./storeRequisitions.vue?vue&type=template&id=b6522fda"
import script from "./storeRequisitions.ts?vue&type=script&lang=js&external"
export * from "./storeRequisitions.ts?vue&type=script&lang=js&external"
import style0 from "./storeRequisitions.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports